import { render } from "./gcs_form.vue?vue&type=template&id=fd18b904"
import script from "./gcs_form.vue?vue&type=script&lang=js"
export * from "./gcs_form.vue?vue&type=script&lang=js"
script.render = render

export default script